import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const Blog = () => {
  const [blogPosts, setBlogPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Appel à l'API pour récupérer tous les articles de blog
    axios.get('https://www.clublfit.org/api/blogposts')
      .then(response => {
        setBlogPosts(response.data);
        setLoading(false);
      })
      .catch(err => {
        setError('Erreur lors de la récupération des articles de blog');
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <p>Chargement des articles...</p>;
  }

  if (error) {
    return <p className="text-danger">{error}</p>;
  }

  return (
    <div className="container my-5">
      <h2 className="display-4 text-center mb-4">Blog des Clubs</h2>
      <div className="row">
        {blogPosts.map(post => (
          <div className="col-md-6 col-lg-4 mb-4" key={post.Id_BlogPost}>
            <div className="card shadow-sm h-100">
              {post.ImageUrl_Post && (
                <img 
                  src={post.ImageUrl_Post} 
                  className="card-img-top" 
                  alt={post.Titre_Post} 
                  style={{ maxHeight: '200px', objectFit: 'cover' }} 
                />
              )}
              <div className="card-body d-flex flex-column">
                <h5 className="card-title text-primary">{post.Titre_Post}</h5>
                <p className="card-text">{post.Excerpt_Post || post.Contenu_Post.substring(0, 100) + '...'}</p>
                <div className="mt-auto">
                  <p className="text-muted">
                    Publié le : {new Date(post.Date_Post).toLocaleDateString()} par le club {post.Nom_Club}
                  </p>
                  <Link to={`/blog/${post.Id_BlogPost}`} className="btn btn-primary">
                    Lire l'article
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      {blogPosts.length === 0 && (
        <p className="text-muted text-center">Aucun article pour l'instant.</p>
      )}
    </div>
  );
};

export default Blog;
